import initialStepValidation from "reducers/work-order/close-step-validation/initialStepValidation";

export default (state, orderId) => {
  let currentValidation =
    state.getIn([
      "workOrderDetails",
      orderId,
      "orderClose",
      "details",
      "stepValidation",
    ]) || initialStepValidation;

  const orderStatus = state.getIn([
    "workOrderDetails",
    orderId,
    "orderClose",
    "details",
    "closeOrderRequest",
    "orderStatus",
  ]);

  const dropBurySet = state.getIn([
    "workOrderDetails",
    orderId,
    "orderClose",
    "details",
    'auxiliary',
    'dropBury'
  ]);

    if (dropBurySet) {
    currentValidation = currentValidation.setIn(
        ["dropBury", "isValid"],
        true
    );
    } else {
    currentValidation = currentValidation.setIn(
      ["dropBury", "isValid"],
      false
    );
  }

  if (orderStatus === "NoAccess") {
    currentValidation = currentValidation.setIn(["dropBury", "isValid"], true);
  }

  return currentValidation;
};



// WEBPACK FOOTER //
// ./src/reducers/work-order/close-step-validation/dropBuryValidator.js